/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForZohoServiceDesk extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForZohoServiceDesk");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForZohoServiceDesk.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForZohoServiceDesk>): ServiceAccountNativeDetailsForZohoServiceDesk {
        let obj = Object.assign(new ServiceAccountNativeDetailsForZohoServiceDesk(), model);
        ServiceAccountNativeDetailsForZohoServiceDesk.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForZohoServiceDesk>): ServiceAccountNativeDetailsForZohoServiceDesk {
        if (!model) return null;
        return ServiceAccountNativeDetailsForZohoServiceDesk.newInstance(<ServiceAccountNativeDetailsForZohoServiceDesk> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForZohoServiceDesk) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForZohoServiceDesk.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForZohoServiceDesk): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForZohoServiceDesk.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
